import React, { createContext, useContext, useState, useEffect, PropsWithChildren } from 'react';
import { useResizeDetector } from 'react-resize-detector';

export const ViewportSizeContext = createContext<{ width: number; height: number } | undefined>(undefined);

export const ViewportSizeProvider = ({ children }: PropsWithChildren): React.JSX.Element => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const { width, height, ref } = useResizeDetector();

  useEffect(() => {
    if (width && height) {
      setSize({ width, height });
    }
  }, [width, height]);

  return (
    <ViewportSizeContext.Provider value={size}>
      <div ref={ref} style={{ width: '100%', height: '100%' }}>
        {children}
      </div>
    </ViewportSizeContext.Provider>
  );
};

export const useViewportSize = () => {
  const context = useContext(ViewportSizeContext);
  if (context === undefined) {
    throw new Error('useViewportSize must be used within a ViewportSizeProvider');
  }
  return context;
};
